<template>
  <div class="specialActivityArea">
    <div class="specialActivity">
      <div>
        <Header class="header"></Header>
        <el-image
          :fit="'contain'"
          id="specialActivity-banner"
          class="bannerImg"
          :src="banner"
          v-if="banner"
          alt="banner"
        />
        <div class="contentArea">
          <Nav v-show="isShow" />
          <div class="content" id="specialActivity-dynamics">
            <Floor
              v-for="(item, index) in dataList"
              :key="index"
              :info="item"
              :id="'floor_' + index"
            ></Floor>
            <div style="text-align: center;" v-show="dataList.length === 0" class="no_show_message">
              <img src="@/assets/img/good/noGood.png">
              <div>暂无数据</div>
            </div>
          </div>
          <LeftMenu
            :dataList="dataList"
          ></LeftMenu>
        </div>
      </div>
    </div>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Header from '@/views/layout/header.vue'
import Footer from '@/views/layout/footer.vue'
import LeftMenu from './components/leftMenu.vue'
import Floor from './components/floor.vue'
import Nav from '@/views/layout/contentInfo/nav.vue'
import Cookies from 'js-cookie'

export default {
  name: 'shopping-scene-purchase',
  components: {
    Header,
    LeftMenu,
    Floor,
    Footer,
    Nav
  },
  data () {
    return {
      dataList: [],
      banner: '',
      bannerHeight: 0,
      isShow: false
    }
  },
  mounted () {
    this.getBanner()
    this.getInfo()
    this.getUserInfo()
    window.addEventListener('scroll', this.getVisible)
  },
  destroyed () {
    window.removeEventListener('scroll', this.getVisible)
  },
  methods: {
    // 获取当前管理员信息
    getUserInfo () {
      return this.$http
        .get('/front/consumer/usercenter/custUserCenterInfo', {
          params: {
            appCode: 'PLANTMATE_OFFICIAL',
            companyId: this.$store.state.user.defaultCompanyId + '' || ''
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          // this.$store.state.cardInfo = res.data.cardInfo
          this.$store.dispatch('companyList', res.data.companyAccountInfo || [])
          this.$store.dispatch('setUserInfo', res.data.userInfo)
          Cookies.set('userId', res.data.userInfo.userId)
          Cookies.set('mobile', res.data.userInfo.mobile)
          // this.$store.state.user.username = res.data.userInfo.username
          // this.$store.state.user.name = res.data.userInfo.name
          // this.$store.state.user.mobile = res.data.userInfo.mobile
          // this.$store.state.user.email = res.data.userInfo.email
        })
        .catch(() => {})
    },
    getBannerHeight () {
      const dom = document.getElementById('specialActivity-banner')
      if (dom) {
        const rect = dom.getBoundingClientRect()
        if (rect.height > this.bannerHeight) {
          this.bannerHeight = rect.height
        }
      }
    },
    // 获取哪些模块在视图里
    getVisible () {
      this.getBannerHeight()
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (this.scrollTop >= this.bannerHeight) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    getBanner () {
      this.$http
        .get(`/front/sys/config/getConfigInfo/SHOPPING_SCENE_PURCHASE_HOME_MAIN_COVER_PC`, {})
        .then(({ data: res }) => {
          if (res.code === 0) {
            if (res.data.configValue) {
              this.banner = JSON.parse(res.data.configValue).url
            }
          }
        })
    },
    getInfo () {
      this.$http
        .get(
          `/front/oms/openapi/shopping-scene-purchase/floor/first-list?includeEntrance=true`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.filter((v) => (v.entranceList || []).length > 0)
          }
        })
    }
  },
  beforeDestroy () {
    window.onreset = () => {}
  },
  beforeCreate () {
    console.log('beforeCreate')
    window.onresize = jumpLink
    jumpLink()
    function jumpLink () {
      const w = window.screen.width
      const minWidth = 900
      if (w < minWidth) {
        const host = window.location.host
        if (host.includes('10.10.56') || host.includes('localhost')) {
          window.location.href =
            window.location.protocol +
            '//' +
            window.location.hostname +
            ':5000/#/pages/Scene/index'
        } else if (host.includes('predev')) {
          window.location.href =
            'http://predevm.plantmate.supcon.com:8888/#/pages/Scene/index'
        } else if (host.includes('pretest')) {
          window.location.href =
            'http://pretestm.plantmate.supcon.com:8888/#/pages/Scene/index'
        } else if (host.includes('uat2')) {
          window.location.href =
            'https://uat2m-plantmate.supcon.com:8888/#/pages/Scene/index'
        } else {
          window.location.href =
            'https://m.plantmate.com/#/pages/Scene/index'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.specialActivity {
  display: flex;
  justify-content: center;
  padding-bottom: 24px;

  .pr-56 {
    padding-right: 56px;
  }
  .contentArea {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .content {
    width: 1200px;
  }
}
.header {
  background-image: none !important;
  background: #fff;
}

.bannerImg {
  width: 100%;
  object-fit: contain;
}
</style>
